import React from "react";
import { darkenColor, primaryColor } from "../utils/comman/Common";
import { useNavigate } from "react-router-dom";

const SearchBar = ({
  search,
  searched,
  searchdata,
  setSearchedBy,
  setSearchedByItemShow,
  clearSearchData,
  bgColor,
  searchedByItemShow,
  searchedBy,
  searchTyping,
  setSearchTyping,
  searchedByItem,
}) => {
  const closeSearch = (e) => {
    console.log("Close button clicked");
    e.stopPropagation();
    e.preventDefault();
    setSearchTyping(false);
  };
  const navigatePage = "/order-request";
  const navigate = useNavigate();
  const navigateTo = () => {
    navigate(navigatePage);
  };
  return (
    <>
      <div
        style={{ backgroundColor: primaryColor }}
        id="upper_margin_at_txn_history"
        className="search allsearch"
      >
        <form autoComplete="off" action="#">
          <div className="autocomplete">
            <input
              id="myInput"
              type="text"
              name=""
              style={{ backgroundColor: primaryColor }}
              placeholder="Search"
              value={searched?.name}
              onChange={searchdata}
            />
            <button
              type="button"
              onClick={clearSearchData}
              style={{
                position: "absolute",
                backgroundColor: darkenColor(primaryColor),
              }}
              className="search-btn"
            ></button>
            {search !== undefined &&
              search !== null &&
              searchedByItemShow &&
              search.length > 1 &&
              searchTyping && (
                <div
                  id="myInputautocomplete-list"
                  className="autocomplete-items"
                  style={{
                    marginTop: "3px",
                    borderTopLeftRadius: "7px",
                  }}
                >
                  <button
                    style={{
                      background: "#9FA6B2",
                      width: "30px",
                      height: "30px",
                      fontSize: "20px",
                      borderRadius: "20px",
                      opacity: 1,
                    }}
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={closeSearch}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  {search !== undefined &&
                    search !== null &&
                    search.length > 1 &&
                    searchedByItem.map((val, index) => {
                      return (
                        <div
                          key={index}
                          onClick={() => {
                            setSearchedBy(val);
                            setSearchedByItemShow(false);
                          }}
                          style={{
                            backgroundColor: `${
                              searchedBy == val ? "#d0d2d6" : "#fff"
                            }`,
                          }}
                        >
                          {val}
                          <input type="hidden" value="Denmark" />
                        </div>
                      );
                    })}
                </div>
              )}
          </div>
        </form>
      </div>
      <div id="upper_margin_at_txn_history">
        <button
          style={{
            // height: "33px",
            backgroundColor: primaryColor,
            marginTop: "23px",
            marginRight: "5px",
            cursor: "pointer",
          }}
          className="btn"
          type="button"
          onClick={navigateTo}
          data-tooltip-id="txn-tooltip-vpa"
          data-tooltip-content={`Click For Manual Payout`}
        >
          Order Request
        </button>
      </div>
    </>
  );
};

export default SearchBar;
